import {
  getNewFeatureInfo,
  setNewFeatureRead,
  closeNewAnnounce,
  getStationMessage,
  readStationMessage
} from '@/services'
export default {
  namespaced: true,
  state: {
    newFeatureInfo: '',
    newNoticeInfo: {},
    stationMessageCount: 0
  },
  mutations: {
    setNewFeatureInfo (state, data) {
      state.newFeatureInfo = data
    },
    setNewNoticeInfo (state, data) {
      state.newNoticeInfo = data
    },
    setStationMessageCount (state, data) {
      state.stationMessageCount = data
    }
  },
  actions: {
    /* 新更新 */
    async getNewFeatureInfo ({ commit }, params) {
      const chain = await getNewFeatureInfo()
      chain.params(params).onSuccess(payload => {
        payload && commit('setNewFeatureInfo', payload.content)
      }).fetch()
      return chain
    },
    async setNewFeatureRead ({ commit }) {
      const chain = await setNewFeatureRead()
        .config({ tip: false })
      return chain
    },
    /* 新公告 */
    async getNewNoticeInfo ({ commit }, params) {
      const chain = await getNewFeatureInfo()
      chain.params(params).onSuccess(payload => {
        payload && commit('setNewNoticeInfo', payload)
      }).fetch()
      return chain
    },
    async closeNewAnnounce ({ commit }, params) {
      const chain = await closeNewAnnounce()
      chain.params(params).fetch()
      return chain
    },
    async getStationMessage ({ commit }, params) {
      const chain = await getStationMessage()
      chain.params(params).fetch()
      return chain
    },
    async readStationMessage ({ commit }, params) {
      const chain = await readStationMessage()
      chain.params(params).fetch()
      return chain
    }
  }
}
